// UPSELL DISCOUNT
const MIN_ITEMS_FOR_DISCOUNT = 2;

// Cart Cache
let cartCache = null;
let isUpdating = false;

// Conta apenas os itens que NÃO são produtos de upsell
// Os produtos de upsell não contam para atingir o mínimo de 2
function countNonUpsellItems(cart) {
  if (!cart || !cart.items) return 0;
  const upsellIds = (typeof UPSELL_VARIANT_IDS !== 'undefined') ? UPSELL_VARIANT_IDS : [];
  let count = 0;
  cart.items.forEach(function(item) {
    if (upsellIds.indexOf(item.variant_id) === -1) {
      count += item.quantity;
    }
  });
  return count;
}

async function openCartDrawer() {
  $('body').addClass('no-scroll');
  $(".cart-cover-hidden").addClass("cart-cover-vis").removeClass("cart-cover-hidden");
  $(".cart-closed").addClass("cart-opened cart-transition").delay(250).queue(function () {
    $(".cart-opened").removeClass("cart-closed cart-transition");
    $(this).dequeue();
  });
  if ($('#add-to-cart-button2').hasClass('enabled')) {
    $('#add-to-cart-button2').addClass('HideForMobile')
    $('.empty-products-section').addClass("ItemsFullWidth")
  }
  if ($('.cart-product-row').length > 1 && window.screen.width < 1024) {
    $('.cart-inner-wrapper').scrollTop(90)
  }
  if ($('.cart-product-row').length > 2 && window.screen.width > 1900) {
    $('.cart-inner-wrapper').scrollTop(180);
  }
}

async function closeCartDrawer() {
  $('body').removeClass('no-scroll');
  $(".cart-opened").addClass("cart-closed cart-transition").removeClass("cart-opened").delay(250).queue(function () {
    $(".cart-closed").removeClass("cart-transition");
    $(".cart-cover").removeClass("cart-cover-vis").addClass("cart-cover-hidden");
    $(this).dequeue();
  });
  $('#add-to-cart-button2').removeClass('HideForMobile')
  $('.empty-products-section').removeClass("ItemsFullWidth")
}

async function getCart() {
  return fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(function (cart) {
      cartCache = cart;
      return cart;
    })
    .catch(function (error) {
      console.error('[CartAPI] getCart error:', error);
      throw error;
    });
}

// Sincronizar a property _upsell_eligible nos itens do carrinho
// Se 2+ itens: adicionar _upsell_eligible nos itens elegíveis
// Se <2 itens: remover _upsell_eligible de todos
async function syncUpsellProperties(cart) {
  if (!cart || !cart.items) return cart;
  
  const shouldHaveDiscount = countNonUpsellItems(cart) >= MIN_ITEMS_FOR_DISCOUNT;
  const eligibleIds = (typeof UPSELL_ELIGIBLE_VARIANT_IDS !== 'undefined') ? UPSELL_ELIGIBLE_VARIANT_IDS : [];
  
  console.log('[UPSELL DEBUG] syncUpsellProperties - items:', cart.item_count, 'shouldDiscount:', shouldHaveDiscount);
  
  // Construir o updates object para /cart/update.js
  // Usamos o formato de line-based updates com properties
  let needsUpdate = false;
  const updates = { items: {} };
  
  for (let i = 0; i < cart.items.length; i++) {
    const item = cart.items[i];
    const isEligible = eligibleIds.indexOf(item.variant_id) !== -1;
    const hasProperty = item.properties && item.properties._upsell_eligible === 'true';
    
    if (shouldHaveDiscount && isEligible && !hasProperty) {
      // Precisa ADICIONAR a property
      needsUpdate = true;
      console.log('[UPSELL DEBUG] Adding _upsell_eligible to line', i + 1, 'variant:', item.variant_id);
    } else if (!shouldHaveDiscount && hasProperty) {
      // Precisa REMOVER a property
      needsUpdate = true;
      console.log('[UPSELL DEBUG] Removing _upsell_eligible from line', i + 1, 'variant:', item.variant_id);
    } else if (shouldHaveDiscount && !isEligible && hasProperty) {
      // Item tem a property mas NÃO é elegível - remover
      needsUpdate = true;
      console.log('[UPSELL DEBUG] Removing _upsell_eligible from non-eligible line', i + 1);
    }
  }
  
  if (!needsUpdate) {
    console.log('[UPSELL DEBUG] No property updates needed');
    return cart;
  }
  
  // Shopify não tem um endpoint para atualizar properties diretamente.
  // A estratégia é: remover e re-adicionar os itens que precisam de mudança.
  // Mas isso é complexo. Em vez disso, vamos usar a abordagem de:
  // 1) Para cada item que precisa mudar, fazer change para qty 0, depois add com novas properties
  
  for (let i = 0; i < cart.items.length; i++) {
    const item = cart.items[i];
    const isEligible = eligibleIds.indexOf(item.variant_id) !== -1;
    const hasProperty = item.properties && item.properties._upsell_eligible === 'true';
    const lineNumber = i + 1; // Shopify usa 1-based
    
    let shouldUpdate = false;
    let newProperties = {};
    
    // Copiar properties existentes
    if (item.properties) {
      Object.keys(item.properties).forEach(function(key) {
        newProperties[key] = item.properties[key];
      });
    }
    
    if (shouldHaveDiscount && isEligible && !hasProperty) {
      newProperties['_upsell_eligible'] = 'true';
      shouldUpdate = true;
    } else if (!shouldHaveDiscount && hasProperty) {
      delete newProperties['_upsell_eligible'];
      shouldUpdate = true;
    } else if (shouldHaveDiscount && !isEligible && hasProperty) {
      delete newProperties['_upsell_eligible'];
      shouldUpdate = true;
    }
    
    if (shouldUpdate) {
      try {
        // Passo 1: Remover o item
        await changeItem({ line: lineNumber, quantity: 0 });
        
        // Passo 2: Re-adicionar com novas properties
        var addOptions = {
          id: item.variant_id,
          quantity: item.quantity,
          properties: newProperties
        };
        await addItem(addOptions);
        
        // Depois de mudar um item, precisamos pegar o cart atualizado
        // porque os line numbers mudaram
        cart = await getCart();
        // Resetar o loop porque os indices mudaram
        i = -1; // Vai para 0 no próximo loop
        
        console.log('[UPSELL DEBUG] Property updated for variant:', item.variant_id);
      } catch(err) {
        console.error('[UPSELL DEBUG] Error updating properties:', err);
      }
    }
  }
  
  // Retornar cart atualizado
  cart = await getCart();
  cartCache = cart;
  return cart;
}

function addItem(options) {
  var id = options && options.id;
  var quantity = (options && options.quantity) || 1;
  var properties = (options && options.properties) || {};

  if (!id) {
    return Promise.reject(new Error('CartAPI.addItem: "id" (variant id) is required.'));
  }

  var formData = new FormData();
  formData.append('id', String(id));
  formData.append('quantity', String(quantity));

  Object.keys(properties).forEach(function (key) {
    var value = properties[key];
    formData.append('properties[' + key + ']', String(value));
  });

  return fetch('/cart/add.js', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(function (lineItem) {
      return lineItem;
    })
    .catch(function (error) {
      console.error('[CartAPI] addItem error:', error);
      throw error;
    });
}

async function changeItem(options) {
  var line = options && options.line;
  var id = options && options.id;
  var quantity = options && options.quantity;

  if (typeof quantity !== 'number') {
    return Promise.reject(new Error('CartAPI.changeItem: "quantity" is required and must be a number.'));
  }

  var formData = new FormData();

  if (line) {
    formData.append('line', String(line));
  } else if (id) {
    formData.append('id', String(id));
  } else {
    return Promise.reject(new Error('CartAPI.changeItem: either "line" or "id" is required.'));
  }

  formData.append('quantity', String(quantity));

  return fetch('/cart/change.js', {
    method: 'POST',
    body: formData,
    headers: {
      'Accept': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    credentials: 'same-origin'
  })
    .then(response => response.json())
    .then(function (cart) {
      cartCache = cart;
      return cart;
    })
    .catch(function (error) {
      console.error('[CartAPI] changeItem error:', error);
      throw error;
    });
}

async function reloadSection(name) {
  if (isUpdating) return Promise.resolve();
  isUpdating = true;
  
  $('.cart-table').addClass('cart-loading');
  
  return fetch(`/?sections=${name}`)
    .then(response => response.json())
    .then(data => {
      const sectionHTML = data[name];
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHTML, 'text/html');
      
      const currentContainer = document.querySelector(`#shopify-section-${name} .cart-table`);
      const newProducts = doc.querySelectorAll('.cart-product-row');
      const oldProducts = currentContainer.querySelectorAll('.cart-product-row');
      
      // Remover produtos antigos
      oldProducts.forEach(el => el.remove());
      
      // Inserir novos produtos
      const insertionPoint = currentContainer.querySelector('div > .supports-cookies')?.parentElement;
      if (insertionPoint) {
        newProducts.forEach(product => {
          currentContainer.insertBefore(product, insertionPoint);
        });
      }
      
      // Atualizar "You May Also Like"
      const newUpsells = doc.querySelector('.you_may_also_like');
      const oldUpsells = currentContainer.querySelector('.you_may_also_like');
      if (newUpsells && oldUpsells) {
        oldUpsells.replaceWith(newUpsells);
      } else if (newUpsells && !oldUpsells) {
        currentContainer.appendChild(newUpsells);
      }
      
      // Atualizar visibilidade do carrinho vazio
      updateEmptyCartVisibility();
      
      $('.cart-table').removeClass('cart-loading');
      isUpdating = false;
      
      // Atualizar preços
      updateLinePrices();
      updateUpsellPrices();
    })
    .catch(error => {
      $('.cart-table').removeClass('cart-loading');
      isUpdating = false;
      throw error;
    });
}

function isGiftItem(item) {
  if (!item || !item.properties) return false;
  const v = item.properties.gift_item;
  return String(v).toLowerCase() === 'true';
}

// Função para formatar preço em moeda
function formatMoney(cents) {
  // Uses Shopify.formatMoney if available (best), else a safe fallback
  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(cents, window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : undefined);
  }
  const n = (Number(cents) || 0) / 100;
  return n.toLocaleString(undefined, { style: 'currency', currency: 'USD' });
}

function updateLinePrices() {
  const cart = cartCache;

  if (!cart || !Array.isArray(cart.items)) {
    getCart().then(updateLinePrices);
    return;
  };

  cart.items.forEach((item) => {
    const key = item.key;
    if (!key) return;

    const row = document.querySelector(`.cart-product-row[data-line-key="${CSS.escape(key)}"]`);
    if (!row) return;

    const totalEl = row.querySelector('[data-role="line-total"]');
    const compareEl = row.querySelector('[data-role="line-compare"]');

    if (!totalEl) return;

    const gift = isGiftItem(item);

    // These are line totals (qty-aware). They match what checkout uses.
    const originalLine = Number(item.original_line_price || 0);
    const finalLine = Number(item.final_line_price || 0);

    if (gift) {
      // Gift item: show FREE + cross out original
      totalEl.textContent = 'FREE';

      if (compareEl) {
        compareEl.textContent = formatMoney(originalLine);
        compareEl.classList.remove('hidden');
      }
      return;
    }

    // Normal line: show final; show crossout only if discounted
    totalEl.textContent = formatMoney(finalLine);

    if (compareEl) {
      if (originalLine > finalLine) {
        compareEl.textContent = formatMoney(originalLine);
        compareEl.classList.remove('hidden');
      } else {
        compareEl.textContent = '';
        compareEl.classList.add('hidden');
      }
    }
  });

  const newItemCount = cart.item_count;
  const newItemTotal = cart.total_price;
  
  $('.subtotal-container .total-price').text(formatMoney(newItemTotal));
  $('.cartItemsCount').text(`(${newItemCount})`);
}

// Calcula o total visual do carrinho (com desconto de upsell)
function calculateVisualTotal(cart) {
  if (!cart || !cart.items) return cart ? cart.total_price : 0;
  const showDiscount = countNonUpsellItems(cart) >= MIN_ITEMS_FOR_DISCOUNT;
  let total = 0;
  cart.items.forEach(function(item) {
    const isUpsellEligible = item.properties && item.properties._upsell_eligible === 'true';
    if (isUpsellEligible && showDiscount) {
      total += Math.round(item.price * 0.9) * item.quantity;
    } else {
      total += item.line_price;
    }
  });
  return total;
}

// Função para atualizar visibilidade do carrinho vazio
function updateEmptyCartVisibility() {
  const hasProducts = $('.cart-product-row').length > 0;
  
  if (hasProducts) {
    $('.supports-cookies').removeClass('show').hide();
    $('.cart-product-row').show();
  } else {
    $('.supports-cookies').addClass('show').show();
    $('.cart-product-row').hide();
  }
}

// Função para atualizar os preços dos itens do carrinho
function updateCartItemPrices() {
  const cart = cartCache;
  if (!cart) {
    getCart().then(updateCartItemPrices);
    return;
  }
  
  const showDiscount = countNonUpsellItems(cart) >= MIN_ITEMS_FOR_DISCOUNT;
  
  // Atualizar cada item do carrinho
  cart.items.forEach(function(item) {
    const $productRow = $(`.cart-product-row:has([data-variant-id="${item.variant_id}"])`);
    
    if ($productRow.length) {
      const unitPrice = item.price;
      const compareAtPrice = item.compare_at_price || item.original_price;
      const isUpsellEligible = item.properties && item.properties._upsell_eligible === 'true';
      
      $productRow.find('.itemPrice').val(unitPrice);
      $productRow.find('.itemCompareAtPrice').val(compareAtPrice);
      
      const $priceElements = $productRow.find('.cart-modal-total');
      
      if (isUpsellEligible && showDiscount) {
        // Mostrar preço com desconto de upsell (10% OFF)
        const discountedUnit = Math.round(unitPrice * 0.9);
        $priceElements.eq(0).addClass('CrossOut').text(formatMoney(unitPrice * item.quantity));
        $priceElements.eq(1).text(formatMoney(discountedUnit * item.quantity));
      } else if (compareAtPrice && compareAtPrice > unitPrice) {
        $priceElements.eq(0).addClass('CrossOut').text(formatMoney(compareAtPrice * item.quantity));
        $priceElements.eq(1).text(formatMoney(item.line_price));
      } else {
        $priceElements.eq(0).removeClass('CrossOut').text('');
        $priceElements.eq(1).text(formatMoney(item.line_price));
      }
    }
  });
  
  // Atualizar subtotal com desconto visual
  const visualTotal = calculateVisualTotal(cart);
  $('.total-price').text(formatMoney(visualTotal));
  $('.cartItemsCount').text(`(${cart.item_count})`);
  
  updateEmptyCartVisibility();
}

// Função para atualizar os preços dos upsells
function updateUpsellPrices() {
  const cart = cartCache;
  if (!cart) return;
  
  const itemCount = cart.item_count;
  const showDiscount = countNonUpsellItems(cart) >= MIN_ITEMS_FOR_DISCOUNT;
  
  $('.suggested_product').each(function() {
    const $product = $(this);
    const isEligible = $product.attr('data-eligible-discount') === 'true';
    
    if (isEligible && showDiscount) {
      $product.find('.original-price').addClass('hidden');
      $product.find('.discounted-price').removeClass('hidden');
      $product.find('.compare-price').removeClass('hidden');
      $product.find('.discount-badge').removeClass('hidden');
    } else {
      $product.find('.original-price').removeClass('hidden');
      $product.find('.discounted-price').addClass('hidden');
      $product.find('.compare-price').addClass('hidden');
      $product.find('.discount-badge').addClass('hidden');
    }
  });
}

async function setData(cart) {
  cartCache = cart;
  const threshold = Number($('.CartItemsContainer').data('shipping-threshold')) || 150;
  const thresholdCents = threshold * 100;
  const progress = Math.min((cart.total_price / thresholdCents) * 100, 100);
  $('.ProgressBarLevel').css('width', `${progress}%`);
  updateLinePrices();
  updateUpsellPrices();
  
  console.log('[UPSELL DEBUG] Cart updated - items:', cart.item_count);
  
  // Sincronizar _upsell_eligible properties nos itens do carrinho
  // Se 2+ itens: adicionar property nos itens elegíveis
  // Se <2 itens: remover property de todos
  syncUpsellProperties(cart).then(function(updatedCart) {
    if (updatedCart !== cart) {
      cartCache = updatedCart;
      updateLinePrices();
      updateUpsellPrices();
      reloadSection('v3-cart');
    }
  }).catch(function(err) {
    console.error('[UPSELL DEBUG] syncUpsellProperties error:', err);
  });
}

$("#cart-icon-bubble, #cart-notification-button, .cart").click(function (event) {
  event.preventDefault();
  openCartDrawer();
});

$(document).on('click', ".cart-cover, .continue, .edit_cart, .cart-close, .mobile-close", function (event) {
  event.preventDefault();
  closeCartDrawer();
});

$(document).on('click', '.suggested_button', function (event) {
  event.preventDefault();
  const variant_id = $(this).data('variant-id');
  const isEligible = String($(this).data('is-eligible')) === 'true';
  const $button = $(this);
  
  console.log('[UPSELL DEBUG] Adding upsell item:', variant_id, 'Eligible:', isEligible);
  
  $button.css('pointer-events', 'none').css('opacity', '0.6');
  $(`.suggested-spinner-${variant_id}`).removeClass('hidden');
  
  const properties = {};
  if (isEligible) {
    properties['_upsell_eligible'] = 'true';
  }
  
  addItem({
    id: variant_id,
    quantity: 1,
    properties: properties
  })
    .then(function () {
      return Promise.all([
        reloadSection('v3-cart'),
        getCart()
      ]);
    })
    .then(function ([_, cart]) {
      console.log('[UPSELL DEBUG] Item added - Cart now has', cart.item_count, 'items');
      setData(cart);
      $(`.suggested-spinner-${variant_id}`).addClass('hidden');
      $button.css('pointer-events', 'auto').css('opacity', '1');
      triggerCartEvents();
    })
    .catch(function (error) {
      console.error('[UPSELL DEBUG] Error adding item:', error);
      alert('Error adding to cart: ' + error.message);
      $(`.suggested-spinner-${variant_id}`).addClass('hidden');
      $button.css('pointer-events', 'auto').css('opacity', '1');
    })
})

function parseRowDiscounts($row) {
  const raw = $row.attr('data-discounts');
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch (e) {
    console.warn('[discount] Invalid JSON in data-discounts:', raw);
    return null;
  }
}

$(document).on('click', '.quantity__button', function () {
  const variant_id = $(this).data('variant-id');
  let quantity = $(this).data('quantity');
  const $row = $(this).closest('.cart-product-row');
  const $input = $row.find('.inputQty2');

  const discount_data = parseRowDiscounts($row);
  const purchase_type = $row.data('purchase-type');
  
  // ATUALIZAÇÃO OTIMISTA - Tudo instantâneo primeiro
  
  // 1. Atualizar input
  $input.val(quantity);
  
  // 2. Atualizar botões
  $row.find('.quantity__button.increase').data('quantity', quantity + 1);
  $row.find('.quantity__button.decrease').data('quantity', Math.max(0, quantity - 1));
  
  // 3. Calcular e atualizar preço localmente (sem esperar servidor)
  if (cartCache && cartCache.items) {
    const item = cartCache.items.find(i => i.variant_id == variant_id);
    if (item) {
      const unitPrice = item.price;
      const compareAtPrice = item.compare_at_price || item.original_price;
      const isUpsellEligible = item.properties && item.properties._upsell_eligible === 'true';
      const qtyDiff = quantity - item.quantity;
      // Contar itens não-upsell para verificar elegibilidade
      const upsellIds = (typeof UPSELL_VARIANT_IDS !== 'undefined') ? UPSELL_VARIANT_IDS : [];
      const isCurrentItemUpsell = upsellIds.indexOf(Number(variant_id)) !== -1;
      let nonUpsellCount = countNonUpsellItems(cartCache);
      if (!isCurrentItemUpsell) {
        nonUpsellCount += qtyDiff;
      }
      const showDiscount = nonUpsellCount >= MIN_ITEMS_FOR_DISCOUNT;
      
      const displayUnit = (isUpsellEligible && showDiscount) ? Math.round(unitPrice * 0.9) : unitPrice;
      const newLinePrice = displayUnit * quantity;
      
      const $priceElements = $row.find('.cart-modal-total');
      
      if (isUpsellEligible && showDiscount) {
        $priceElements.eq(0).addClass('CrossOut').text(formatMoney(unitPrice * quantity));
        $priceElements.eq(1).text(formatMoney(newLinePrice));
      } else if (compareAtPrice && compareAtPrice > unitPrice) {
        $priceElements.eq(0).addClass('CrossOut').text(formatMoney(compareAtPrice * quantity));
        $priceElements.eq(1).text(formatMoney(unitPrice * quantity));
      } else {
        $priceElements.eq(0).removeClass('CrossOut').text('');
        $priceElements.eq(1).text(formatMoney(unitPrice * quantity));
      }
      
      // Calcular novo subtotal visual
      let newVisualTotal = 0;
      cartCache.items.forEach(i => {
        const iEligible = i.properties && i.properties._upsell_eligible === 'true';
        const iUnit = (iEligible && showDiscount) ? Math.round(i.price * 0.9) : i.price;
        if (i.variant_id == variant_id) {
          newVisualTotal += iUnit * quantity;
        } else {
          newVisualTotal += iUnit * i.quantity;
        }
      });
      
      $('.total-price').text(formatMoney(newVisualTotal));
      
      // Progress bar usa total real
      let realTotal = 0;
      cartCache.items.forEach(i => {
        if (i.variant_id == variant_id) {
          realTotal += i.price * quantity;
        } else {
          realTotal += i.line_price;
        }
      });
      const threshold = Number($('.CartItemsContainer').data('shipping-threshold')) || 150;
      const thresholdCents = threshold * 100;
      const progress = Math.min((realTotal / thresholdCents) * 100, 100);
      $('.ProgressBarLevel').css('width', `${progress}%`);
    }
  }
  
  // Agora sim, chamar o servidor em background (sem bloquear UI)
  changeItem({
    id: variant_id,
    quantity: quantity
  })
    .then(function (cart) {
      cartCache = cart;
      updateLinePrices();
      updateUpsellPrices();
      
      const threshold = Number($('.CartItemsContainer').data('shipping-threshold')) || 150;
      const thresholdCents = threshold * 100;
      const progress = Math.min((cart.total_price / thresholdCents) * 100, 100);
      $('.ProgressBarLevel').css('width', `${progress}%`);

      reloadSection('v3-cart');
      triggerCartEvents();
    })
    .catch(function(error) {
      console.error('Error updating quantity:', error);
      // Em caso de erro, recarregar do servidor
      getCart().then(cart => {
        cartCache = cart;
        const item = cart.items.find(i => i.variant_id == variant_id);
        if (item) {
          $input.val(item.quantity);
          updateLinePrices();
        }
      });
    })
})

$(document).on('click', '.cart-product-remove', function () {
  const variant_id = $(this).data('variant-id');
  const $row = $(this).closest('.cart-product-row');
  
  // REMOÇÃO INSTANTÂNEA - remover visualmente primeiro
  $row.fadeOut(150, function() {
    $(this).remove();
    
    // Atualizar subtotal instantaneamente (com desconto visual)
    if (cartCache && cartCache.items) {
      const item = cartCache.items.find(i => i.variant_id == variant_id);
      if (item) {
        // Contar itens não-upsell após remoção
        const upsellIds = (typeof UPSELL_VARIANT_IDS !== 'undefined') ? UPSELL_VARIANT_IDS : [];
        const isRemovedItemUpsell = upsellIds.indexOf(Number(variant_id)) !== -1;
        let nonUpsellCount = countNonUpsellItems(cartCache);
        if (!isRemovedItemUpsell) {
          nonUpsellCount -= item.quantity;
        }
        const newItemCount = cartCache.item_count - item.quantity;
        const showDiscount = nonUpsellCount >= MIN_ITEMS_FOR_DISCOUNT;
        
        let newVisualTotal = 0;
        cartCache.items.forEach(i => {
          if (i.variant_id == variant_id) return;
          const iEligible = i.properties && i.properties._upsell_eligible === 'true';
          const iUnit = (iEligible && showDiscount) ? Math.round(i.price * 0.9) : i.price;
          newVisualTotal += iUnit * i.quantity;
        });
        
        $('.total-price').text(formatMoney(newVisualTotal));
        $('.cartItemsCount').text(`(${newItemCount})`);
        
        const threshold = Number($('.CartItemsContainer').data('shipping-threshold')) || 150;
        const thresholdCents = threshold * 100;
        const realTotal = cartCache.total_price - item.line_price;
        const progress = Math.min((realTotal / thresholdCents) * 100, 100);
        $('.ProgressBarLevel').css('width', `${progress}%`);
      }
    }
    
    // Verificar se carrinho está vazio
    updateEmptyCartVisibility();
  });

  // Sincronizar com servidor em background
  changeItem({
    id: variant_id,
    quantity: 0
  })
    .then(function (cart) {
      cartCache = cart;
      updateLinePrices();
      
      const threshold = Number($('.CartItemsContainer').data('shipping-threshold')) || 150;
      const thresholdCents = threshold * 100;
      const progress = Math.min((cart.total_price / thresholdCents) * 100, 100);
      $('.ProgressBarLevel').css('width', `${progress}%`);
      
      updateEmptyCartVisibility();
      
      // Recarregar upsells (produtos podem voltar a aparecer)
      reloadSection('v3-cart');
      triggerCartEvents();
    })
    .catch(function(error) {
      console.error('Error removing item:', error);
      // Em caso de erro, recarregar tudo
      location.reload();
    })
})

function triggerCartEvents() {
  try {
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { source: 'pdp-atc' } }));
    document.dispatchEvent(new CustomEvent('cart.requestComplete'));
  } catch (_) {}
  
  if (window.jQuery) {
    try {
      $(document).trigger('cart:refresh');
      $(document).trigger('cart.requestComplete');
      $(document).trigger('cart:updated');
    } catch (_) {}
  }
}

$(document).on('click', '.featured_button', async function (ev) {
  ev.preventDefault();

  const variantId = Number($(this).data('variant-id'));
  const qty = Number($('input[name="quantity"]:checked')?.val() || 1);
  const type = $('input[name="purchase_type"]:checked')?.val() || 'one-time';

  $('.spinner-wrapper', this).removeClass('hidden');
  $(this).prop('disabled', true);

  let discountCode = null;
  try {
    if (typeof discountData !== 'undefined' && discountData[type] && discountData[type][qty]) {
      const entry = discountData[type][qty];
      if (entry && entry.code) discountCode = String(entry.code).trim() || null;
    }
  } catch (_) {}

  let planId = null;
  if (type === 'subscription') {
    const planFromRadio = $('#purchase-subscription')?.data('selling-plan-id') || null;
    planId = Number(planFromRadio || SUB_PLAN_ID || 0) || null;
  }

  var button = $(this);

  addItem({
    id: variantId,
    quantity: qty,
    sellingPlanId: planId,
    properties: null,
    discountCode
  })
    .then(function () {
      return Promise.all([
        reloadSection('v3-cart'),
        getCart()
      ]);
    })
    .then(function ([_, cart]) {
      triggerCartEvents();
      $('.spinner-wrapper', button).addClass('hidden');
      $(button).prop('disabled', false);
      setData(cart);
      openCartDrawer();
    })
    .catch(function (error) {
      alert('Error adding to cart: ' + error.message);
      $('.spinner-wrapper', button).addClass('hidden');
      $(button).prop('disabled', false);
    })
});

$(document).ready(function() {
  getCart().then(function(cart) {
    setData(cart);
    updateEmptyCartVisibility();
  });

  // Substituir handler de checkout
  $('#cart_submit_button').off('click').on('click', async function(e) {
    e.preventDefault();
    
    const cart = await getCart();
    
    // Garantir que properties estão sincronizadas antes do checkout
    await syncUpsellProperties(cart);
    
    // Verificar se há desconto do sessionStorage
    var existingDiscount = sessionStorage.getItem("discount_code");
    if (existingDiscount) {
      window.location.href = '/discount/' + existingDiscount + '?redirect=/checkout';
    } else {
      window.location.href = '/checkout';
    }
  });

  // Warning popup de presale
  $(document).on('click', '.warning-pop-accept', async function(e) {
    e.preventDefault();
    
    const cart = await getCart();
    await syncUpsellProperties(cart);
    
    var existingDiscount = sessionStorage.getItem("discount_code");
    if (existingDiscount) {
      window.location.href = '/discount/' + existingDiscount + '?redirect=/checkout';
    } else {
      window.location.href = '/checkout';
    }
  });
});